import { render, staticRenderFns } from "./ServiceSupplementsLayout.vue?vue&type=template&id=3fbc6ec3"
import script from "./ServiceSupplementsLayout.vue?vue&type=script&lang=js"
export * from "./ServiceSupplementsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports